var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blocked-block"},[_c('div',{staticClass:"blocked-block__img"},[_c('BlockerIcon')],1),_c('div',{staticClass:"blocked-block__inner color-red"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }